import clsx from "clsx"
import {
  ReactNode, useState
} from "react"

interface Props {
  label: ReactNode
  dropdown: ReactNode
}

const FooterMenuItem = (props: Props) => {
  const {
    label, dropdown 
  } = props

  const [expanded, setExpanded] = useState(false)

  return (
    <div>
      <div
        onClick={() => {
          setExpanded((x) => !x)
        }}
        className={clsx(
          "flex cursor-pointer lg_cursor-default items-center justify-between lg_block",
          "border-b-1 border-solid border-E7DED5 lg_border-b-[0]",
          "px-[15px] py-5 lg_px-0 lg_py-0"
        )}
      >
        <h3 className={clsx("  text-[17px] leading-6 text-#403732")}>{label}</h3>
        <span
          className={clsx(
            " relative h-3 w-3 ",
            'before_content-[""] after_content-[""]',
            "before_h-0.5 before_w-full after_h-0.5 after_w-full",
            "before_bg-80583F",
            "before_absolute before_left-1/2 before_top-1/2 before_-translate-x-1/2 before_-translate-y-1/2",
            "after_absolute after_left-1/2 after_top-1/2 after_-translate-x-1/2 after_-translate-y-1/2",
            "after_rotate-90",
            expanded ? "after_bg-transparent" : "after_bg-80583F",
          )}
        />
      </div>
      <div className={clsx(expanded ? "block" : "hidden", "lg_block")}>
        {dropdown}
      </div>
    </div>
  )
}

export default FooterMenuItem
